<template>
    <div class="cdc-details">
        <div class="full-container">
            <div class="top-navbar">
                <div class="row align-items-center">
                    <div class="col-md-4">
                        <div class="top-navbar-left">
                            <div class="btn-back" @click="$router.push({ name: 'cdcSummary' });">
                                <font-awesome-icon :icon="['fas', 'angle-left']" />
                                Back
                            </div>
                        </div>
                    </div> 
                    
                    <div class="col-md-4">
                        <div class="top-navbar-center">
                            cdc Details
                        </div>
                    </div>    

                    <div class="col-md-4">
                        <div class="top-navbar-right">
                            <button @click="exportCdc" class="btn btn-ecdc btn-shadow ml-3">Export Report</button>
                        </div>
                    </div>                       
                </div>
            </div>

            <hr />

            <div class="row">
                <transition name="fade" mode="out-in">
                    <div v-show="toggleFilter" id="side-filter-col" class="col-lg-3">
                        <div class="side-filter">

                            <div class="title">
                                Filter
                            </div>

                            <div class="form-group">
                                <div class="label">Division</div>

                                <div>
                                    <div class="custom-control-inline pill-radio">
                                        <input id="north" type="checkbox" name="division" value="0" required class="custom-control-input" v-model="filter.division" @change="onChangeDivision()">
                                        <label class="" for="north">East</label>
                                    </div>
                                    <div class="custom-control-inline pill-radio">
                                        <input id="south" type="checkbox" name="division" value="1" required class="custom-control-input" v-model="filter.division" @change="onChangeDivision()">
                                        <label class="" for="south">West</label>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="label">Region</div>
                                <app-multi-select 
                                    :options="regionOptions.map(regionOption => regionOption.id)"
                                    :custom-label="opt => regionOptions.find(x => x.id == opt).name"
                                    :multiple="true"
                                    :close-on-select="false"
                                    :clear-on-select="false"
                                    :preserve-search="true" 
                                    :preselect-first="false"
                                    :placeholder="'-- All Region --'"
                                    v-model="filter.region"
                                    @input="onChangeRegion">
                                        <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} selected</span></template>
                                </app-multi-select>

                                <div class="selected-label" v-if="filter.region.length > 0">
                                    FILTER:
                                    <div v-for="region in filter.region" :key="region">{{ regionOptions.find(x => x.id == region).name}}</div>
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="label">Area</div>

                                <div class="custom-modal-select" :class="{ 'selected': filter.area.length > 0 }" v-b-modal.area-modal>
                                    <input type="button" class="form-control" :value="filter.area.length > 0 ? filter.area.length + ' selected' : '-- All Area --'">
                                </div>

                                <div class="selected-label" v-if="filter.area.length > 0">
                                    FILTER:
                                    <div v-for="area in filter.area" :key="area">{{ areaOptions.find(x => x.id == area).name}}</div>
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="label">Date</div>

                                <!-- <app-datepicker :format="customFormatter" v-model="filter.date"></app-datepicker> -->
                                <div class="custom-modal-select selected">
                                    <input type="button" class="form-control" id="datepicker-trigger"
                                    placeholder="Select dates"
                                    :value="formatDates(dateOne, dateTwo)">
                                </div>
                               
                                <AirbnbStyleDatepicker
                                :trigger-element-id="'datepicker-trigger'"
                                    :mode="'range'"
                                    :fullscreen-mobile="true"
                                    :date-one="dateOne"
                                    :date-two="dateTwo"
                                    :show-shortcuts-menu-trigger="false"
                                    @date-one-selected="val => { dateOne = val }"
                                    @date-two-selected="val => { dateTwo = val }"
                                />
                            </div>

                            <div class="filter-action">
                                <button type="button" class="btn btn-ecdc btn-block" @click="setFilter()">Apply</button>
                                <button type="button" class="btn btn-link btn-block text-light" @click="clearFilter()">Clear Filter</button>
                            </div>
                        </div>
                    </div>
                </transition>

                <div id="table-content-col" :class="toggleFilter ? 'col-lg-9 filter-expanded' : 'col-lg'">

                    <div class="table-options row justify-content-between align-items-center">
                        <div class="col-sm">
                            <button @click='toggleFilter = !toggleFilter' type="button" class="btn btn-ecdc btn-filter">Filter</button>

                            <!-- <div class="table-search form-inline d-inline-block ml-4">
                                <input type="text" class="form-control" placeholder="Search by keyword">                         <button type="button" class="btn btn-ecdc btn-circle">
                                    <app-icon-search></app-icon-search>
                                </button>       
                            </div> -->
                        </div>
                        <div class="col-sm mt-3 mt-sm-0">
                            <app-paginate
                                :page-count="totalPage"
                                :click-handler="pagination"
                                :prev-text="'&laquo;'"
                                :next-text="'&raquo;'"
                                ref="paginateTop"
                                :container-class="'pagination justify-content-end'">
                            </app-paginate>
                        </div>
                    </div>

                    

                    <div class="table-responsive">
                        <table class="table table-hover table-striped result-table">
                            <thead>
                                <tr>
                                    <th>Team Name</th>
                                    <th>TL Name</th>
                                    <th>Division</th>
                                    <th>Region</th>
                                    <th class="text-right">Number of CDC</th>
                                    <th class="text-center">Action</th>
                                </tr>
                            </thead>

                            <tbody v-if="!isLoading">
                                <tr v-for="cdc in cdcData.result" v-bind:key="cdc.tid">
                                    <td>{{cdc.team_name}}</td>
                                    <td>{{cdc.tl_name}}</td>
                                    <td>{{cdc.division}}</td>
                                    <td>{{cdc.region_name}}</td>
                                    <td class="text-right">{{cdc.number_of_cdc}}</td>
                                    <td class="text-center" @click="view(cdc.work_progress_tl_id)">
                                        <button class="btn btn-link btn-icon icon-right">
                                            View 
                                            <font-awesome-icon class="icon" :icon="['fas', 'angle-right']" />
                                        </button>
                                    </td>
                                </tr>
                                <tr v-if="cdcData.result.length == 0">
                                    <td colspan="6">
                                        No result found.
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="row justify-content-between align-items-cetner table-options">
                        <div class="col-lg col-6">
                            <select class="form-control custom-select" v-model="pageLimit" @change="pagination(1)">
                                <option value="15">15</option>
                                <option value="30">30</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                            per page
                        </div>
                        <div class="col-lg text-lg-center text-right col-6">
                            {{ showingResults }}
                        </div>
                        <div class="col-lg mt-lg-0 mt-3">
                            <app-paginate
                                :page-count="totalPage"
                                :click-handler="pagination"
                                :prev-text="'&laquo;'"
                                :next-text="'&raquo;'"
                                ref="paginateBottom"
                                :container-class="'pagination justify-content-end'">
                            </app-paginate>

                        </div>
                    </div>

                </div>
            </div>
        </div>

        <b-modal id="area-modal" hide-header hide-footer centered size="xl">
            <img src="../assets/img/icon-close.png" alt="icon-close" class="img-fluid modal-close" @click="$bvModal.hide('area-modal')" /> 

            <div class="selection-modal">
                <h4 class="title text-left mb-5">Area</h4>

                <div class="form-group">
                    <div class="row">
                        <div v-for="area in areaOptions" v-bind:key="area.id" class="col-4 col-xl-2">
                            <div class="custom-control custom-checkbox form-check-inline">
                                <input class="custom-control-input" type="checkbox" :id="'inlineCheckbox' + area.id" :value="area.id" v-model="filter.area">
                                <label class="custom-control-label" :for="'inlineCheckbox' + area.id">{{ area.name }}</label>
                            </div>
                        </div>
                    </div>
                </div>

                <div>
                    <button type="button" class="btn btn-ecdc" @click="$bvModal.hide('area-modal')">Done</button>
                    <button type="button" class="btn btn-link text-muted" @click="clearArea()">Clear Selection</button>
                </div>
            </div>
        </b-modal>
        <app-loader v-show="isLoading"></app-loader>
    </div>
</template>

<script>
import { getCdc, getRegions, getAreas, getCdcReport } from '../api'
import Loader from './Loader.vue'
import Paginate from 'vuejs-paginate'
// import IconSearch from '../svg/Search.vue'
import Multiselect from 'vue-multiselect'
// import Datepicker from 'vuejs-datepicker'
import moment from 'moment'
import format from 'date-fns/format'
import { getProj } from '../helpers/index'


export default {
    components: {
        appLoader: Loader,
        appPaginate: Paginate,
        // appIconSearch: IconSearch,
        appMultiSelect: Multiselect,
        // appDatepicker: Datepicker,
    },
    data() {
        return {
            filter: {
                division: [],
                region: [],
                area: [],
                dateStart: moment(new Date()).format('YYYY-MM-DD'),
                dateEnd: moment(new Date()).format('YYYY-MM-DD')
            },
            regions: [],
            regionOptions: [],
            areas: [],
            areaOptions: [],
            cdcData: "",
            isLoading: true,
            proj_id: "2",
            canCreate: false,
            canEdit: false,
            totalPage: 0,
            pageLimit: 15,
            showingResults: "",
            toggleFilter: true,
            dateFormat: 'YYYY-MM-DD',
            dateOne: moment(new Date()).format('YYYY-MM-DD'),
            dateTwo: moment(new Date()).format('YYYY-MM-DD')
        }
    },
    async mounted() {
        this.proj_id = getProj().projId;
        await this.getCdc(1);
        await this.getRegions();
        await this.getAreas();
        this.isLoading = false;
    },
    methods: {
        formatDates(dateOne, dateTwo) {
            let formattedDates = ''
            if (dateOne) {
                formattedDates = format(dateOne, this.dateFormat)
            }
            if (dateTwo) {
                formattedDates += ' - ' + format(dateTwo, this.dateFormat)
            }
            return formattedDates
        },
        async getCdc(pageNum) {

            try {
                this.filter.dateStart = this.dateOne;
                this.filter.dateEnd = this.dateTwo;
                const result = await getCdc(this.filter, pageNum, this.pageLimit);

                this.cdcData = result.data.data;
                this.totalPage = this.cdcData.total / this.pageLimit;

                if(this.totalPage % 1 != 0)
                    this.totalPage = parseInt(this.totalPage) + 1;
                else
                    this.totalPage = parseInt(this.totalPage);

                var startPage = 1;
                
                if(pageNum != 1)
                    startPage = (this.pageLimit * (pageNum - 1)) + 1;

                var endPage = pageNum * this.pageLimit;

                if(endPage >= this.cdcData.total)
                    endPage = this.cdcData.total;

                this.showingResults = "Showing " + startPage + " - " + endPage + " of " + this.cdcData.total + " results";
            }
            catch(err) {
                alert(err.response.data.message);
            }
        },
        async pagination(pageNum) {

            this.isLoading = true;  
            
            if(pageNum != 0)
                this.$refs.paginateTop.selected = this.$refs.paginateBottom.selected = pageNum;
            else 
                pageNum = this.$refs.paginateBottom.selected;

            await this.getCdc(pageNum);

            this.isLoading = false;
        },
        view(wptlid) {
            this.$router.push({ name: "cdcByTeam" , params: { 'wptlid': wptlid }});
        },
        async getRegions() {

            try {
                const result = await getRegions();
                this.regions = result.data.data;
                this.regionOptions = this.regions;
            }
            catch(err) { 
                alert(err.response.data.message);
            }
        },
        async getAreas() {

            try {
                const result = await getAreas();
                this.areas = result.data.data;
                this.areaOptions = this.areas;
            }
            catch(err) {
                alert(err.response.data.message);
            }
        },
        onChangeDivision() {
            
            const _this = this;
            this.regionOptions = [];
            this.filter.region = [];
            this.areaOptions = this.areas;
            this.filter.area = [];

           if(this.filter.division.length > 0) {

                this.filter.division.forEach(division => {

                    const found = _this.regions.filter(value => value.division == division);

                    found.forEach(value => {
                        _this.regionOptions.push(value);
                    });
                });
            }
            else {

                this.regionOptions = this.regions;
            }
        },
        onChangeRegion() {
            
            const _this = this;
            this.areaOptions = [];
            this.filter.area = [];

            if(this.filter.region.length > 0) {

                this.filter.region.forEach(region => {

                    const found = _this.areas.filter(value => value.region_id == region);
                    
                    found.forEach(value => {
                        _this.areaOptions.push(value);
                    });
                });
            }
            else {

                this.areaOptions = this.areas;
            }
        },
        clearArea() {
            
            this.filter.area = [];
        },
        clearFilter() {
            
            this.filter.division = [];
            this.filter.region = [];
            this.filter.area = [];
            this.filter.dateStart = moment(new Date()).format('YYYY-MM-DD');
            this.filter.dateEnd = moment(new Date()).format('YYYY-MM-DD');

            this.regionOptions = this.regions;
            this.areaOptions = this.areas;
        },
        async setFilter() {

            this.isLoading = true;
            await this.getCdc(1);
            this.isLoading = false;
        },
        customFormatter(date) {
            return moment(date).format('YYYY-MM-DD');
        },
        async exportCdc() {
            this.isLoading = true;
            try {
                this.filter.dateStart = this.dateOne;
                this.filter.dateEnd = this.dateTwo;
                const result = await getCdcReport(this.filter);

                let fileURL = window.URL.createObjectURL(new Blob([result.data]));
                let fileLink = document.createElement("a");

                fileLink.href = fileURL;

                let moment = require("moment");
                let date = moment().format("DDMMYYYY");

                fileLink.setAttribute("download", `CDC_${date}.xlsx`);

                document.body.appendChild(fileLink);
                fileLink.click();

                this.isLoading = false;
            } catch (err) {
                alert(err.response.data.message);
            }
            this.isLoading = false;
        }
    }
}
</script>